module.exports = __webpack_public_path__ + "static/media/metodopagologo.9e3978dd.svg";